module.exports = __webpack_public_path__ + "media/images/pic/bialoleka/team/teachers/edyta-a66b20f57792e2a1e6faee852020b6cb.webp";